"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterWindow = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FilterWindow = (param)=>{
    let { isOpen, onClose, onClear, onSubmit, title, children, settings } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const footer = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                    fullWidth: true,
                    "data-testid": getTestId(_constants.FILTER_WINDOW_SUBMIT_BUTTON),
                    color: "primary",
                    variant: "contained",
                    onClick: onSubmit,
                    children: settings.submitButtonTitle
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                    fullWidth: true,
                    "data-testid": getTestId(_constants.FILTER_WINDOW_CLEAR_BUTTON),
                    color: "default",
                    variant: "text",
                    onClick: onClear,
                    children: settings.clearButtonTitle
                })
            ]
        }), [
        getTestId,
        onClear,
        onSubmit,
        settings.clearButtonTitle,
        settings.submitButtonTitle
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledResponsiveDialog, {
        header: title,
        open: isOpen,
        footer: footer,
        onClose: onClose,
        children: children
    });
};
exports.FilterWindow = FilterWindow;
